import { useNavigation } from "@react-navigation/native";
import React from "react";
import { ImageBackground, Pressable, StyleSheet, View } from "react-native";
import Text from "@components/AppText";
import { scale, verticalScale } from "../../utils/scale";
import { WidgetContactShop } from "@constants/analyticsEventsCT";
import analytics from "@services/analytics";
const ContactSyncBanner = ({
  cl_title,
  cl_subtitle,
  image_link,
}) => {
  const navigation = useNavigation();
  return (
    <View>
      <ImageBackground source={{ uri: image_link }} style={styles.topContainer}>
        <View style={[styles.itemAsRow, { marginTop: verticalScale(5) }]}>
          <Text style={{ fontSize: scale(16), fontWeight: "bold" }}>
            {cl_title || ""}
          </Text>
        </View>
        <View style={styles.itemAsRow}>
          <Text
            style={{
              fontSize: scale(14),
              paddingRight: scale(10),
              flex: 1,
            }}
          >
            {cl_subtitle || ""}
          </Text>
          <Pressable
            onPress={() => {
              navigation.navigate("Customer", { fromCustomer: true });
              analytics.trackEvent(WidgetContactShop.WIDGET_CONTACT_ADD_CTA);
            }}
            style={styles.customerButton}
          >
            <Text
              style={{ fontSize: scale(16), fontWeight: "700", color: "#fff" }}
            >
              कस्टमर जोड़ें
            </Text>
          </Pressable>
        </View>
      </ImageBackground>
    </View>
  );
};

const styles = StyleSheet.create({
  topContainer: {
    width: scale(345),
    alignSelf: "center",
    height: verticalScale(100),
    borderRadius: scale(6),
    alignSelf: "center",
    overflow: "hidden",
    paddingTop: verticalScale(20),
  },
  itemAsRow: {
    marginHorizontal: scale(20),
    flexDirection: "row",
  },
  customerButton: {
    width: scale(135),
    height: verticalScale(40),
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 6,
    backgroundColor: "#E40046",
  },
});

export default ContactSyncBanner;
